module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The DMC Series")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("OFFICER-CADET"), _c('br'), _vm._v("LIEUTENANT"), _c('br'), _vm._v("CAPTAIN"), _c('br'), _vm._v("MAJOR"), _c('br'), _vm._v("LIEUTENANT COLONEL"), _c('br'), _vm._v("COLONEL")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Other Books by Rick Shelley")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Spec Ops Squad")]), _c('br'), _vm._v("HOLDING THE LINE"), _c('br'), _vm._v("DEEP STRIKE"), _c('br'), _vm._v("SUCKER PUNCH")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Lucky 13th")]), _c('br'), _vm._v("UNTIL RELIEVED"), _c('br'), _vm._v("SIDE SHOW"), _c('br'), _vm._v("JUMP PAY")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Federation War")]), _c('br'), _vm._v("THE BUCHANAN CAMPAIGN"), _c('br'), _vm._v("THE FIRES OF COVENTRY"), _c('br'), _vm._v("RETURN TO CAMEREIN")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Varayan Memoir")]), _c('br'), _vm._v("SON OF THE HERO"), _c('br'), _vm._v("THE HERO OF VARAY"), _c('br'), _vm._v("THE HERO KING")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Seven Towers")]), _c('br'), _vm._v("THE WIZARD AT MECQ"), _c('br'), _vm._v("THE WIZARD AT HOME")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0095f0e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/0441005683_epub_atb_r1.vue
// module id = 60
// module chunks = 0